var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9493 5.97C19.9255 5.46847 19.7156 4.99382 19.3605 4.63879C19.0055 4.28375 18.5309 4.07382 18.0293 4.05C17.3293 4.02 16.6593 4 16.0093 4C10.9793 4 7.48933 4.97 5.54933 6.91C1.86933 10.59 2.39933 15.81 5.63933 18.81H5.64933C7.00651 15.0154 9.74565 11.8727 13.3193 10.01C13.1093 10.19 8.61933 13.59 7.80933 20.26C8.85933 20.74 10.0093 21.01 11.1693 21.01C13.2193 21.01 15.3293 20.21 17.0893 18.46C19.2793 16.26 20.2293 12.1 19.9493 5.97Z",
    fill: "#171717",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoor);
export default __webpack_public_path__ + "static/media/outdoor.578160e194e5d2dd6ae48723141e621e.svg";
export { ForwardRef as ReactComponent };